export default async function initRocket() {
    let mapButton = document.getElementById('rocket-map-button');
    let mapWrapper = document.getElementById('rocket-map');
    let footerAddress = document.getElementById('footer-address');
    if (!mapButton || !mapWrapper || !footerAddress) return;

    mapButton.addEventListener('click', () => {
        mapWrapper.classList.toggle('hidden');
    });

    let pickups = JSON.parse(mapWrapper.dataset.pickups);
    ymaps.ready(function () {
        let map = new ymaps.Map('rocket-map', {
            center: [55.76, 37.64],
            zoom: 5,
        });
        let cluster = new ymaps.Clusterer();
        let points = [];
        for (let i = 0; i < pickups.length; i++) {
            let pickup = pickups[i];
            points[i] = new ymaps.GeoObject({
                geometry: {
                    type: 'Point',
                    coordinates: [pickup.lat, pickup.lon]
                },
                properties: {
                    balloonContentHeader: pickup.balloonContentHeader,
                    balloonContentBody: pickup.balloonContentBody,
                    balloonContentFooter: pickup.balloonContentFooter,
                },
            });
        }
        cluster.add(points);
        map.geoObjects.add(cluster);

        map.geoObjects.events.add('balloonopen', function () {
            let buttonSelect = document.getElementById('rocket-pvz-select');
            let streetInputField = document.getElementsByName('properties[STREET]')[0];
            if (!buttonSelect || !streetInputField) return;

            buttonSelect.addEventListener('click', () => {
                let pickupId = buttonSelect.dataset.pickup;
                if (!pickupId) return;

                let pickup = pickups.filter((p) => parseInt(p.id) === parseInt(pickupId))[0];
                let addressValue = pickup.balloonContentHeader + ': ' + pickup.address;
                streetInputField.value = addressValue;
                footerAddress.innerText = addressValue;

                mapWrapper.classList.toggle('hidden');
            });
            //
        });
    });
}
